<template>
  <header v-if="isMobileView">
    <div v-if="isMobileView" class="mobile-nav-toggle" @click="toggleMobileMenu">
      <button type="button" class="mobile-nav-toggle-button" @mousedown="toggleMobileMenu" v-if="!isMenuActive">
        <icon-hamburger-open />
      </button>
      <button type="button" class="mobile-nav-toggle-button" @mousedown="toggleMobileMenu" v-if="isMenuActive">
        <icon-hamburger-close />
      </button>
    </div>
    <div v-if="isMobileView && !isMenuActive" class="mobile-logo-container">
      <div class="logo">
        <router-link to="/">
          <img src="/images/nav-logo.png" width="550" height="136" alt="Perlman Law Logo" />
        </router-link>
      </div>
    </div>
  </header>

  <div class="mobile-nav-overlay" v-if="isMobileView && isMenuActive">
    <div class="mobile-nav-overlay-content">
      <div class="mobile-nav-overlay-header">
        <div class="logo">
          <router-link to="/">
            <img src="/images/nav-logo.png" width="550" height="136" alt="Perlman Law Logo"
              style="object-fit: cover;" />
          </router-link>
        </div>
      </div>
      <nav v-if="isMenuActive" class="mobile-nav">
        <li>
          <router-link to="/" :class="{ active: page === 'practice-area' }" @click="closeMobileMenu">Practice
            Area</router-link>
        </li>
        <li>
          <router-link to="/about-us" :class="{ active: page === 'about-us' }" @click="closeMobileMenu">About
            Us</router-link>
        </li>
        <li>
          <router-link to="/attorneys" :class="{ active: page === 'attorneys' }"
            @click="closeMobileMenu">Attorneys</router-link>
        </li>
        <li>
          <router-link to="/clients" :class="{ active: page === 'clients' }"
            @click="closeMobileMenu">Clients</router-link>
        </li>
        <li>
          <router-link to="/contact-us" :class="{ active: page === 'contact-us' }" @click="closeMobileMenu">Contact
            Us</router-link>
        </li>
        <li>
          <router-link to="/disclaimer" :class="{ active: page === 'disclaimer' }"
            @click="closeMobileMenu">Disclaimer</router-link>
        </li>
      </nav>
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted, onBeforeUnmount } from 'vue'
import { sniff } from '../../utils/Sniffer.js'
import IconHamburgerOpen from '../icons/IconHamburgerOpen.vue'
import IconHamburgerClose from '../icons/IconHamburgerClose.vue'

const isMobile = ref(false)
const isMobileView = ref(window.innerWidth < 768)
const innerWidth = ref(window.innerWidth)
const isMenuActive = ref(false)

const toggleMobileMenu = () => {
  isMenuActive.value = !isMenuActive.value
}

const handleResize = () => {
  innerWidth.value = window.innerWidth
  isMobileView.value = window.innerWidth < 768
  if (window.innerWidth >= 768) {
    isMenuActive.value = false
  }
}

const closeMobileMenu = () => {
  isMenuActive.value = false
}

let handleResizeFunc = null

onMounted(() => {
  handleResizeFunc = handleResize
  isMobile.value = sniff().isMobileDevice
  isMobileView.value = window.innerWidth < 768
  window.addEventListener('resize', handleResizeFunc)
})

onBeforeUnmount(() => {
  try {
    if (handleResizeFunc) {
      window.removeEventListener('resize', handleResizeFunc)
    }
  } catch (error) {
    console.warn(error)
  }
})
</script>

<style scoped>
/* Header */

header {
  width: 100%;
  height: 75px;
  background-color: #fefefe;
  display: flex;
  justify-content: space-between;
  align-items: center;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 1002;
  flex-direction: column;
  position: relative;
  /* position: fixed; */
}

nav {
  height: 100%;
}

/* Logo */

.logo {
  width: 100%;
  height: auto;
  display: flex;
  align-items: center;
  margin: 0 auto;
  padding: 0;
}

.logo>a {
  height: 100%;
  width: auto;
  margin: 0 auto;
  padding: 0;
}

.logo>a>img {
  width: 100%;
  height: auto;
  display: flex;
  align-items: center;
  justify-content: center;
}

/* Mobile Nav */

.mobile-nav {
  /* display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
  width: 100%;
  margin: 0;
  padding: 0;
  list-style: none; */
}

.mobile-nav>li {
  /* margin: 0;
  padding: 0; */
}

.mobile-nav>li>a {
  /* text-decoration: none;
  cursor: pointer;
  padding: 0;
  margin: 0 0 0 20px;
  text-decoration: none;
  color: var(--nav-links-dark);
  font-family: var(--nav-links-font-family);
  font-size: 25px;
  line-height: 50px;
  text-wrap: nowrap; */
}

.mobile-nav>li>a:hover,
.mobile-nav>li>a.active {
  /* color: var(--nav-links-hover-dark); */
}

/* Mobile Nav Toggle */

.mobile-nav-toggle {
  display: flex;
  justify-content: flex-end;
  align-items: flex-end;
  width: 100%;
  height: 75px;
  margin-right: 15px;
}

.mobile-nav-toggle-button {
  background: transparent;
  border: none;
  cursor: pointer;
  height: 75px;
  display: flex;
  justify-content: center;
  align-items: center;
}

/* Mobile Nav Overlay */

.mobile-nav-overlay {
  position: fixed;
  top: 75px;
  left: 0;
  width: calc(100% - 0px);
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 1001;
  margin: 0 auto;
}

.mobile-nav-overlay-content {
  width: 100%;
  height: 100%;
  background-color: #fefefe;
}

/* Mobile Logo Container */

.mobile-logo-container {
  margin: 0 auto;
  padding: 0;
  width: 100%;
  max-width: 550px;
  height: auto;
  background-color: transparent;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

/* Mobile Overlay Header */

.mobile-nav-overlay-header {
  margin: 0px auto;
  /* padding: 0 20px 20px 20px; */
  padding: 0;
  width: calc(100% - 0px);
  height: auto;
  background-color: transparent;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.mobile-nav-overlay-content>nav {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
  width: 100%;
  margin: 0;
  padding: 0;
  list-style: none;
  /*  */
  display: flex;
  justify-content: center;
  align-items: center;
  /* height: calc(100dvh - 185px); */
  /* height: calc(100dvh - 400px); */
  height: calc(100dvh - 250px);
  min-height: 300px;
  margin-right: 2rem;
  flex-direction: column;
  list-style: none;
}

.mobile-nav-overlay-content>nav>li {
  margin: 0;
  padding: 0;
  white-space: nowrap;
}

.mobile-nav-overlay-content>nav>li>a {
  text-decoration: none;
  cursor: pointer;
  padding: 0;
  margin: 0 0 0 20px;
  text-decoration: none;
  color: var(--nav-links-dark);
  font-family: var(--nav-links-font-family);
  font-size: 25px;
  line-height: 50px;
  text-wrap: nowrap;
}

.mobile-nav>li>a:hover,
.mobile-nav>li>a:active {
  color: var(--nav-links-hover-dark);
}

.router-link-active.router-link-exact-active,
.router-link-active router-link-exact-active,
.router-link-active.router-link-exact-active.active,
.router-link-active router-link-exact-active active,
.desktop-nav>li>a.router-link-active.router-link-exact-active.active {
  color: var(--nav-links-hover-dark);
}
</style>
